
export class InputPrvwFilterViewModel {
    farmId: string = "";
    collookupFarmId: string = "";
    nodeType: string = "";
    previewType: string = "";
    transfrmrInputprvwCacheKey: string = "";

    resetProps() {
        this.farmId = "";
        this.collookupFarmId = "";
        this.nodeType = "";
        this.previewType = "";
        this.transfrmrInputprvwCacheKey = "";
    }
}
